// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.
export class GeneralSett {
    public Language = 'en';
    public CurrentTheme = 'dark';
    public EnableSounds = true;
    public OnboardInFirstTimeShowed = false;
    public DisableInactivityPeriod = false;
    public LogSnapshotHasBeenSent = false;
}
